import React, { useRef } from "react";
import useCardSpotlight from "../../hooks/useCardSpotlight";

/**
 * SpotlightGrid \u2014 a thin wrapper that turns its children into
 * cursor-aware cards. Anything inside that matches `cardSelector`
 * will get --card-mx / --card-my CSS variables updated as the cursor
 * moves over it. Pair with CSS that paints a radial-gradient on those
 * coords (see project-item.styles.css ::before with --card-mx/--card-my).
 */
const SpotlightGrid = ({
  children,
  className = "",
  cardSelector = ".js-spotlight-card",
  as: Tag = "div",
  ...rest
}) => {
  const ref = useRef(null);
  useCardSpotlight(ref, cardSelector);
  return (
    <Tag ref={ref} className={className} {...rest}>
      {children}
    </Tag>
  );
};

export default SpotlightGrid;
